module.exports = __webpack_public_path__ + "img/Jesse-Hyson.5028a95d.jpeg";